module.exports = __webpack_public_path__ + "img/ic_qu_check_off.6b927c01.svg";